<template>
  <td
    class="tw-whitespace-nowrap tw-px-2 tw-py-1.5 tw-font-normal"
    :class="className"
    v-bind="$attrs"
  >
    <slot />
  </td>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps<{
  className?: Record<string, boolean> | string[] | string;
}>();

const { className } = toRefs(props);
</script>
